import type {
	ProductUsageAreaGroup,
	ProductUsageTrend,
	ProductUsageWindow,
} from "@signalist/shared-types";

export const formatCount = (value: number) => Number(value).toLocaleString("en-GB");
export const formatPercent = (share: number) => `${(Number(share) * 100).toFixed(1)}%`;
export const formatNullable = (value: number | null, notMeasured: string) =>
	value === null ? notMeasured : Number(value).toFixed(1);
export function formatTrend(trend: ProductUsageTrend, newLabel: string): string {
	if (trend.kind === "none") {
		return "—";
	}

	if (trend.kind === "new") {
		return newLabel;
	}

	const percent = Number(trend.percent);

	return `${percent > 0 ? "+" : ""}${percent.toFixed(1)}%`;
}
export function formatDate(date: string): string {
	return new Intl.DateTimeFormat("en-GB", {
		day: "numeric",
		month: "short",
		year: "numeric",
		timeZone: "UTC",
	})
		.format(new Date(`${date}T00:00:00Z`))
		.replace("Sept", "Sep");
}
export function formatWindow(window: ProductUsageWindow | null): string {
	if (!window) {
		return "—";
	}

	const from = formatDate(window.from);

	return `${window.from.slice(0, 4) === window.to.slice(0, 4) ? from.replace(/ \d{4}$/, "") : from} – ${formatDate(window.to)}`;
}
export function sortWithinAreas<Row>(
	groups: readonly ProductUsageAreaGroup<Row>[],
	value: (row: Row) => string | number | null,
	direction: "asc" | "desc"
): ProductUsageAreaGroup<Row>[] {
	return groups.map((group) => ({
		...group,
		features: [...group.features].sort((a, b) => {
			const left = value(a),
				right = value(b);

			if (left === right) {
				return 0;
			}

			if (left === null) {
				return 1;
			}

			if (right === null) {
				return -1;
			}

			const order =
				typeof left === "string" && typeof right === "string"
					? left.localeCompare(right)
					: Number(left) - Number(right);

			return direction === "asc" ? order : -order;
		}),
	}));
}
